
import { Component, Vue } from "vue-property-decorator";
import CompanyInfo from "@/components/company/CompanyInfo.vue";
import CompanySmsOptions from "@/components/company/CompanySmsOptions.vue";
import router from "@/router";
import OptionsList from "@/components/options/OptionsList.vue";

@Component({
    components: {
        CompanyInfo,
        OptionsList,
        CompanySmsOptions,
    },
})
export default class Company extends Vue {
    private currentTab: string = "info";
    private company: any = {
      name: "",
      type: "",
      activitySector: "",
      siret: "",
      siren: "",
      users: [],
      masterId: undefined,
    };

    private mounted() {
      if (this.$route.params.id) {
        this.getCompany();
      }
      if (this.$route.params.tab) {
        this.currentTab = this.$route.params.tab;
      }
    }

    private async getCompany(): Promise<void> {
      await this.$store.dispatch("admin/companies/readById", {
        id: this.$route.params.id,
        options: {
          master: true,
        },
      }).then((data) => {
        this.company = data;
        this.company.users = [data.master];
        this.company.masterId = data.master.id;
      });
    }

    private changeTab(tab): void {
      this.currentTab = tab;
    }

    private async updateCompany(company: any): Promise<void> {
      this.$store.dispatch("admin/companies/updateById", {
        id: company.id,
        company,
      }).then((res) => {
          router.push({name: "companies"});
      }).catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: this.$t(`register.error.${err.response.data.type}`),
        });
      });
    }
}
